import { TextControl, PanelRow, TextareaControl, ToggleControl } from '@wordpress/components'
import { dispatch, useSelect } from '@wordpress/data'
import { __ } from '@wordpress/i18n'
import Select from 'react-select'

export default ({allData}) => {
   
    const {pricing_type, custom_booking_type, custom_booking_link, custom_booking_link_text, custom_booking_link_open_in_new_tab, custom_booking_form}  = allData;
    const { updateTripData } = dispatch('WPTravel/TripEdit')

    let customBookingTypes = [
        {label: __( 'Custom Link', 'wp-travel-pro' ), value: 'custom-link' },
        {label: __( 'Custom Form', 'wp-travel-pro' ), value: 'custom-form' },
    ]
    let selectedCustomBookingType = customBookingTypes.filter( (t) => { return t.value == custom_booking_type } )
    selectedCustomBookingType = 'undefined' != typeof selectedCustomBookingType[0] ? selectedCustomBookingType[0] : {}
    return <>
    {'custom-booking' === pricing_type && <>
            	
                <PanelRow>
                    <label>{__( 'Custom booking type', 'wp-travel-pro' )}</label>
                    <div className="wp-travel-select-wrapper">
                        <Select
                            options={customBookingTypes}
                            defaultValue={ selectedCustomBookingType }
                            onChange={(val)=>{
                                if ( '' !== val ) {
                                    let customBookingType = customBookingTypes.filter( data => {
                                        return val.label == data.label
                                    } ).map( data => {
                                        return data.value
                                    } );
                                    customBookingType = 'undefined' != typeof customBookingType[0] ? customBookingType[0] : {}
                                    updateTripData({
                                        ...allData, // allData
                                        custom_booking_type: customBookingType
                                    })
                                }
                            }}

                        />
                    </div>
                </PanelRow>
                { 'custom-link' == custom_booking_type && <>
                
                    <PanelRow>
                        <label>{__( 'Link', 'wp-travel-pro' )}</label>
                        <TextControl
                            value={ custom_booking_link }
                            type="text"
                            placeholder={__( 'http://example.com/booking', 'wp-travel-pro' )}
                            autoComplete="off"
                            onChange={(link) => {
                                updateTripData({
                                    ...allData, // allData
                                    custom_booking_link: link
                                })
                            }}
                        />
                    </PanelRow>
                    {/* <PanelRow>
                        <label>{__( 'Link label', 'wp-travel-pro' )}</label>
                        <TextControl
                            value={ custom_booking_link_text }
                            type="text"
                            placeholder={__( 'Book Now', 'wp-travel-pro' )}
                            autoComplete="off"
                            onChange={(txt) => {
                                updateTripData({
                                    ...allData, // allData
                                    custom_booking_link_text: txt
                                })
                            }}
                        />
                    </PanelRow> */}
                    <PanelRow>
                        <label>{ __( 'Open link in new tab', 'wp-travel-pro' ) }</label>
                        <ToggleControl
                            checked={ custom_booking_link_open_in_new_tab }
                            onChange={ () => {
                                updateTripData({
                                    ...allData,
                                    custom_booking_link_open_in_new_tab:!custom_booking_link_open_in_new_tab
                                })
                            } }
                        />
                    </PanelRow>
                </>}
                { 'custom-form' == custom_booking_type && <>
                    <PanelRow>
                        <label>{__( 'Custom form HTML', 'wp-travel-pro' )}</label>
                        <TextareaControl
                            value={custom_booking_form}
                            placeholder={__( 'Place your html here.', 'wp-travel-pro' )}
                            onChange={
                                (e) => {
                                    updateTripData({
                                        ...allData, // allData
                                        custom_booking_form: e
                                    })
                                }
                            }
                        />
                    </PanelRow>
                </>}
            </> }
    </>
}